// Otto chat configuration
export const OTTO_HISTORY_MESSAGE_LIMIT = 100;
export const OTTO_TITLE_TRUNCATE_LENGTH = 50;
export const OTTO_LAST_MESSAGE_PREVIEW_LENGTH = 100;

// Default messages
export const OTTO_WELCOME_MESSAGE = "Hey Brandon! I'm Otto, your personal assistant. How can I help you today?";

// Auto-save configuration
export const AUTO_SAVE_DEBOUNCE_MS = 2000;
